define([
	"dijit/form/Button",
	"./_Plugin",
	"./PluginFactory"
], function(Button,_Plugin,PluginFactory) {

	return PluginFactory.declare([Button, _Plugin], {
		materialIcon: "redo",
		pluginName: "redo",
		title: "CanvasRedo",

		/**
		 * Only enable when in default mode and there are operations to redo
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			return this.editor.isRedoAllowed();
		},

		/**
		 * Redo click event
		 * @param {Event} e
		 */
		onClick: function(e) {
			this.editor.redo();
		}
	});
});
